import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-container" }
const _hoisted_2 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: _ctx.$t('search'),
      class: "search-input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalSearchText) = $event)),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.triggerSearch && _ctx.triggerSearch(...args)), ["enter"]))
    }, null, 40, _hoisted_2), [
      [_vModelText, _ctx.internalSearchText]
    ]),
    (_ctx.internalSearchText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "clear-icon",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerClear && _ctx.triggerClear(...args)))
        }, " × "))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "search-icon",
      style: {"cursor":"pointer"},
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.triggerSearch && _ctx.triggerSearch(...args)))
    }, [...(_cache[4] || (_cache[4] = [
      _createElementVNode("i", { class: "fas fa-search" }, null, -1)
    ]))])
  ]))
}